import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function BridgeYourCreativeVision() {
  return <section id="bridge-your-creative-vision" className="relative w-full min-h-[90vh] flex items-center overflow-hidden bg-background bg-[radial-gradient(ellipse_at_top_right,var(--color-muted)_0%,transparent_60%)]">
      <div className="container mx-auto px-6 md:px-12 py-24 lg:py-32">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12 lg:gap-0">
          
          <div className="w-full lg:w-[55%] z-10 relative lg:pr-12 xl:pr-20">
            <h1 className="font-serif text-5xl md:text-7xl font-bold text-primary leading-[1.1] tracking-tighter">
              From Unknown to <br className="hidden md:block" />
              <span className="text-accent italic">Unmissable</span>
            </h1>
            
            <p className="font-sans text-lg md:text-xl text-foreground/80 leading-relaxed mt-8 max-w-xl">
              Transform your creative struggles into strategic success. We provide personalized consulting and high-impact programs designed specifically for B2B founders to scale their impact.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-5 mt-12">
              <Button asChild size="lg" className="bg-accent text-accent-foreground hover:bg-accent/90 h-14 px-10 text-base font-medium rounded-lg shadow-xl shadow-accent/20 transition-all duration-300 hover:-translate-y-1">
                <Link to="/ServicesPage">
                  View VIP Programs
                  <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
              
              <Button asChild variant="outline" size="lg" className="border-primary text-primary hover:bg-primary/5 hover:text-primary h-14 px-10 text-base font-medium rounded-lg transition-all duration-300 hover:-translate-y-1">
                <Link to="https://forms.gle/9i15ksGjFmCNLpMT6" newTab>
                  Free Strategy Call
                </Link>
              </Button>
            </div>
          </div>

          <div className="w-full lg:w-[42%] z-0 relative group">
            <div className="relative w-full aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl shadow-primary/10 border border-border/50 transform transition-transform duration-1000 group-hover:scale-[1.02]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1589716/img/executive_creative_vision_strategy.png" alt="Executive professional in a refined workspace reviewing a high-impact growth strategy" className="w-full h-full object-cover grayscale-[20%] contrast-[1.1]" />
              <div className="absolute inset-0 bg-primary/10 mix-blend-multiply pointer-events-none"></div>
              <div className="absolute inset-0 bg-gradient-to-t from-primary/30 via-transparent to-transparent pointer-events-none"></div>
            </div>
            
            <div className="absolute -bottom-8 -right-8 w-2/3 h-2/3 bg-accent rounded-full -z-10 opacity-15 blur-3xl"></div>
            <div className="absolute -top-8 -left-8 w-1/2 h-1/2 bg-primary rounded-full -z-10 opacity-5 blur-3xl"></div>
          </div>

        </div>
      </div>
    </section>;
}